import { cx } from '@hrworks/design-system/functions';

import { S } from './Divider.styles';
import type { DividerProps } from './Divider.types';

export const Divider = ({ className, marginBlock = '8px', ...otherProps }: DividerProps) => (
  <S.Divider className={cx(S.cls.Divider, className)} marginBlock={marginBlock} {...otherProps} />
);
